import questionListSlice from '../slices/paper_generation/question/QuestionList';
import questionDetailsSlice from '../slices/paper_generation/question/QuestionDetails';
import questionBankListSlice from '../slices/paper_generation/question_bank/QuestionBankList';
import questionBankDetailsSlice from '../slices/paper_generation/question_bank/QuestionBankDetails';
import examListSlice from '../slices/paper_generation/exam/ExamList';
import examDetailsSlice from '../slices/paper_generation/exam/ExamDetails';
import examQuestionListSlice from '../slices/paper_generation/exam_question/ExamQuestionList';
import testDesignerListSlice from '../slices/paper_generation/test_designer/TestDesignerList';
import testDesignerDetailsSlice from '../slices/paper_generation/test_designer/TestDesignerDetails';
import examInvitationListSlice from '../slices/paper_generation/exam_invitation/ExamInvitationList';
import eligibleStudentListSlice from '../slices/paper_generation/exam_invitation/EligibleStudentList';
import courseStudentListSlice from '../slices/paper_generation/exam_invitation/CourseStudentList';
import availableExamSlotsSlice from '../slices/paper_generation/exam_slot/AvailableExamSlots';

const paperGenerationReducer = {
    questionList: questionListSlice,
    questionDetails: questionDetailsSlice,
    questionBankList: questionBankListSlice,
    questionBankDetails: questionBankDetailsSlice,
    examList: examListSlice,
    examDetails: examDetailsSlice,
    examQuestionList: examQuestionListSlice,
    testDesignerList: testDesignerListSlice,
    testDesignerDetails: testDesignerDetailsSlice,
    examInvitationList: examInvitationListSlice,
    eligibleStudentList: eligibleStudentListSlice,
    courseStudentList: courseStudentListSlice,
    availableExamSlots: availableExamSlotsSlice,
};

export default paperGenerationReducer;
